import PropTypes from 'prop-types';
import DebugLogger from "../../../helpers/DebugLogger";

import "./DropDownList.scss";
import { IconJsxer } from '../../../helpers/IconHelper';
import { useState } from 'react';

const DropDownList = (props) => {
    const {
        id,
        items,
        currentIndex,
        selectFunc,
        error,
        deselectedClass,
        selectedClass,
        listClass,
        deselectedLabel,
        icon,
        showErrors,
        enabled,
        className,
        canSearch,
        getItemClassName,
        getItemStyle,
        menuAlign,
        menuStyle,
        menuMinWidth,
        menuMaxWidth,
        menuWidth,
        allowItemWrap,
    } = props;

    // console.log('Drop down: ', items, currentIndex)
    console.log("items = ",items);
    const selected = !items[currentIndex].deselect;

    const [open, setOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const toggleOpen = (e) => {
        if (enabled) {
            if (open) {
                setOpen(false);
                setSearchTerm('');
            } else {
                setOpen(true);
            }
        } else {
            closeList();
        }
    }
    const closeList = () => {
        setOpen(false);
        setSearchTerm('');
    }

    const filteredItems = (canSearch && searchTerm)
        ? items.map((item, i) => ({ ...item, _originalIndex: i })).filter(item =>
            item.label?.toLowerCase().includes(searchTerm.toLowerCase())
          )
        : items.map((item, i) => ({ ...item, _originalIndex: i }));

    const toCssSize = (val) => {
        if (typeof val === 'number') {
            return `${val}px`;
        }
        return val;
    };

    const computedMenuStyle = {
        ...(menuStyle || {}),
    };
    if (typeof menuMinWidth !== 'undefined' && menuMinWidth !== null) {
        computedMenuStyle.minWidth = toCssSize(menuMinWidth);
    }
    if (typeof menuMaxWidth !== 'undefined' && menuMaxWidth !== null) {
        computedMenuStyle.maxWidth = toCssSize(menuMaxWidth);
    }
    if (typeof menuWidth !== 'undefined' && menuWidth !== null) {
        computedMenuStyle.width = toCssSize(menuWidth);
    }

    const selectedItem = items[currentIndex] || null;
    const selectedItemClassName = typeof getItemClassName === 'function'
        ? getItemClassName(selectedItem, currentIndex, { selected: true, open, id, isOption: false }) || ''
        : '';
    const selectedItemStyle = typeof getItemStyle === 'function'
        ? getItemStyle(selectedItem, currentIndex, { selected: true, open, id, isOption: false }) || undefined
        : undefined;

    const listClasses = [
        'drop-down-list',
        listClass,
        (!enabled ? 'drop-down-list-disabled' : ''),
        (menuAlign === 'right' ? 'drop-down-list--align-right' : ''),
        (allowItemWrap ? 'drop-down-list--wrap-items' : ''),
    ].filter(Boolean).join(' ');
    const selectItem = (e, origIndex) => {
        if (enabled && selectFunc) {
            items[origIndex].index = origIndex;
            // Just make these nice and robust!
            if (typeof items[origIndex].value === 'undefined' && items[origIndex].val !== undefined) {
                items[origIndex].value = items[origIndex].val;
            }
            selectFunc(e, id, items[origIndex]);
        }
        if (selectFunc === null) {
            DebugLogger.warn('You should provide a prop called selectFunc(e, id, item) to DropDownList. The component should be controlled by passing in the currentIndex as a prop, the index can be found as part of the item data passed back to your selectFunc. DropDownList does NOT track it\'s own state!');
        }
    }

    const renderItemLabel = (item, fallbackLabel = null) => {
        const showMarker = item?.colorCss && item?.profilePicBorderCss;
        const label = fallbackLabel || item?.label;

        return (
            <>
                {showMarker && (
                    <span
                        className={`account-type-marker ${item.colorCss} ${item.profilePicBorderCss}`}
                        aria-hidden="true"
                    ></span>
                )}
                <div className='label-holder'>{label}</div>
            </>
        );
    };

    return (
        <>
        {open && <div className="drop-down-canceller" onClick={closeList}></div>}
        <div id={id} className={`drop-list-holder${className ? ` ${className}` : ''}`} onClick={toggleOpen}>
            <div
                className={`drop-down-closed top-row ${selected ? selectedClass : deselectedClass} ${!enabled ? "drop-down-disabled" : ""}${selectedItemClassName ? ` ${selectedItemClassName}` : ''}`}
                style={selectedItemStyle}
            >
                {(icon) ? IconJsxer.GetIcon(typeof icon === 'string' ? IconJsxer.ICONS[icon] : icon, IconJsxer.ICON_STYLES.roundFormControl) : null}
                {selected ? renderItemLabel(items[currentIndex]) : <div className='label-holder'>{deselectedLabel || items[currentIndex].label}</div>}
                { enabled && IconJsxer.GetIcon(IconJsxer.ICONS.chevronDown, IconJsxer.ICON_STYLES.roundFormControl)}
            </div>
            {open &&

                <div className={listClasses} style={computedMenuStyle} onClick={e => e.stopPropagation()}>
                    <div className={`top-row item${selectedItemClassName ? ` ${selectedItemClassName}` : ''}`} style={selectedItemStyle} onClick={toggleOpen}>
                        {(icon) ? IconJsxer.GetIcon(typeof icon === 'string' ? IconJsxer.ICONS[icon] : icon, IconJsxer.ICON_STYLES.roundFormControl) : null}
                        {selected ? renderItemLabel(items[currentIndex]) : <div className='label-holder'>{deselectedLabel || items[currentIndex].label}</div>}
                        {IconJsxer.GetIcon(IconJsxer.ICONS.chevronUp, IconJsxer.ICON_STYLES.roundFormControl)}
                    </div>

                    {canSearch && (
                        <div className="drop-down-search-row" onClick={e => e.stopPropagation()}>
                            <input
                                className="drop-down-search-input"
                                type="text"
                                placeholder="Search…"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                autoFocus
                            />
                        </div>
                    )}

                    {filteredItems.map((val) => {
                        const origIndex = val._originalIndex;
                        const optionClassName = typeof getItemClassName === 'function'
                            ? getItemClassName(val, origIndex, { selected: origIndex === currentIndex, open, id, isOption: true }) || ''
                            : '';
                        const optionStyle = typeof getItemStyle === 'function'
                            ? getItemStyle(val, origIndex, { selected: origIndex === currentIndex, open, id, isOption: true }) || undefined
                            : undefined;
                        return (
                            <div
                                className={`item${origIndex !== currentIndex ? ' option' : ''}${val.disabled ? ' drop-down-separator' : ''}${optionClassName ? ` ${optionClassName}` : ''}`}
                                style={optionStyle}
                                onClick={(e) => { selectItem(e, origIndex); closeList(); }}
                                key={id + '_' + origIndex}
                            >
                                <div className="drop-down-item-content">
                                    {renderItemLabel(val)}
                                </div>
                            </div>
                        );
                    })}

                    {canSearch && searchTerm && filteredItems.length === 0 && (
                        <div className="drop-down-no-results">No results</div>
                    )}
                </div>
            }
            {showErrors &&
            <div className="error">
                {error}&nbsp;
            </div>
            }
        </div>
        </>
    )
}

DropDownList.propTypes = {
    id: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentIndex: PropTypes.number.isRequired,
    selectFunc: PropTypes.func,
    error: PropTypes.string.isRequired,
    deselectedClass: PropTypes.string.isRequired,
    selectedClass: PropTypes.string.isRequired,
    deselectedLabel: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.any]),
    showErrors: PropTypes.bool.isRequired,
    enabled: PropTypes.bool,
    className: PropTypes.string,
    canSearch: PropTypes.bool,
    getItemClassName: PropTypes.func,
    getItemStyle: PropTypes.func,
    menuAlign: PropTypes.oneOf(['left', 'right']),
    menuStyle: PropTypes.object,
    menuMinWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    menuMaxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    menuWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    allowItemWrap: PropTypes.bool,
};

DropDownList.defaultProps = {
    id: 'drop_list',
    items: [
        {
            id: 'none',
            label: 'None',
            deselect: true,
        },
        {
            id: 'item1',
            label: 'Item 1',
        },
        {
            id: 'item2',
            label: 'Item 2',
        },
        {
            id: 'item3',
            label: 'Item 4',
        },
    ],
    currentIndex: 0,
    selectFunc: null,
    error: 'Some error',
    deselectedClass: '',
    selectedClass: 'default-selected',
    listClass: 'default-selected',
    deselectedLabel: 'Choose Item',
    icon: null,
    showErrors: false,
    enabled: true,
    className: '',
    canSearch: false,
    getItemClassName: null,
    getItemStyle: null,
    menuAlign: 'left',
    menuStyle: null,
    menuMinWidth: null,
    menuMaxWidth: null,
    menuWidth: null,
    allowItemWrap: false,
}

export default DropDownList;
